import { createI18n } from 'vue-i18n';
import messages from '@/locales/index.ts';

const i18n = createI18n({
  legacy: false, // 使用 Composition API 模式
  locale: 'zh', // 默认语言设置为中文
  fallbackLocale: 'zh', // 设置回退语言
  messages // 设置翻译信息
});

// 动态设置语言
export const updateLocale = (locale: 'zh' | 'en') => {
  i18n.global.locale.value = locale;
};

export default i18n;